import React, { useEffect, useState } from "react";
import "./AppCatalog.css";
import { db } from "../../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Box, Typography } from "@mui/material";

// Import all app components
import OktaApp from "../applications/OktaApp";
import GoogleApp from "../applications/GoogleApp";
import SlackApp from "../applications/SlackApp";
import HibobApp from "../applications/HibobApp";
import AsanaApp from "../applications/AsanaApp";
import ServiceNowApp from "../applications/ServiceNowApp";
import BambooHRApp from "../applications/BambooHRApp";
import MicrosoftTeamsApp from "../applications/MicrosoftTeamsApp";
import GuruApp from "../applications/GuruApp";
import MondayApp from "../applications/MondayApp";
import OneLoginApp from "../applications/OneLoginApp";

// Map app names to components for dynamic rendering
const appComponents = {
  Okta: OktaApp,
  "Google Workspace": GoogleApp,
  Slack: SlackApp,
  Hibob: HibobApp,
  Asana: AsanaApp,
  ServiceNow: ServiceNowApp,
  BambooHR: BambooHRApp,
  "Microsoft Teams": MicrosoftTeamsApp,
  Guru: GuruApp,
  "monday.com": MondayApp,
  "OneLogin": OneLoginApp,

};

const AppCatalog = () => {
  const [apps, setApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null); // New error state

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const snapshot = await getDocs(collection(db, "applications"));
        const appsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setApps(appsData);
      } catch (error) {
        console.error("Error fetching applications:", error);
        setError("Failed to fetch applications. Please try again later.");
      }
    };
    fetchApps();
  }, []);

  const handleIconClick = (app) => {
    if (!appComponents[app.name]) {
      setError(`No component available for ${app.name}.`);
      setSelectedApp(null);
      return;
    }
    setError(null); // Clear previous error messages
    setSelectedApp(app);
  };

  const handleCloseSidebar = () => {
    setSelectedApp(null);
    setError(null); // Clear error when sidebar closes
  };

  const filteredApps = apps.filter((app) =>
    app.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const renderStatusBadge = (connected) => (
    <span className={connected ? "status-badge connected" : "status-badge not-connected"}>
      {connected ? "Connected" : "Not Connected"}
    </span>
  );

  const SelectedAppComponent = selectedApp
    ? appComponents[selectedApp.name] || null
    : null;

  return (
    <div className="app-catalog-container">
      <div className="app-catalog-toolbar">
        {/*<h2 className="toolbar-title">Application Catalog</h2>*/}
        <Box className="application-catalog" sx={{ padding: 3 }}>
        <Typography
          variant="h4"
          gutterBottom
          //className="nextui-app-catalog-header"
        >
          Application Catalog
        </Typography>
        <input
          type="text"
          placeholder="Search applications..."
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </Box>
      </div>

      {/* Error Alert Section */}
      {error && (
        <div className="error-alert-enterprise">
          <strong>Error:</strong> {error}
        </div>
      )}

      <div className="app-grid">
        {filteredApps.map((app) => (
          <div className="app-card" key={app.id} onClick={() => handleIconClick(app)}>
            <img src={app.icon} alt={`${app.name} icon`} className="app-icon" />
            <h3>{app.name}</h3>
            {renderStatusBadge(app.connected)}
          </div>
        ))}
      </div>

      {/* Sidebar with dynamic app content */}
      {selectedApp && SelectedAppComponent && (
        <div className="app-sidebar slide-in">
          <button onClick={handleCloseSidebar} className="close-btn">
            X
          </button>
          <SelectedAppComponent
            selectedApp={selectedApp}
            handleCloseSidebar={handleCloseSidebar}
          />
        </div>
      )}
    </div>
  );
};

export default AppCatalog;